import React from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import AuthLayout from 'components/Layouts/Auth';
import ErrorScreen from 'components/shared/ErrorScreen';
import { AUTH_INVITATION_PATH, AUTH_PASSWORD_RESET_PATH, LOGIN_PATH, RESET_PATH, SIGN_IN_PATH } from 'constants/routes';

import InvitationPasswordForm from '../Pages/Auth/InvitationPasswordForm';
import ResetPasswordForm from '../Pages/Auth/ResetPasswordForm';

const isDev = process.env.NODE_ENV === 'development';

function AuthRoutes() {
  return (
    <AuthLayout>
      <Switch>
        <Route path={SIGN_IN_PATH} exact>
          {isDev ? (
            (() => {
              const SignIn = React.lazy(() => import('../Pages/Auth/SignIn'));
              return (
                <React.Suspense fallback={null}>
                  <SignIn />
                </React.Suspense>
              );
            })()
          ) : (
            <Redirect push to={LOGIN_PATH} />
          )}
        </Route>

        <Route path={AUTH_INVITATION_PATH} component={InvitationPasswordForm} exact />
        <Route path={AUTH_PASSWORD_RESET_PATH} component={ResetPasswordForm} exact />
        <Route render={() => <ErrorScreen status="404" />} />
      </Switch>
    </AuthLayout>
  );
}

export default AuthRoutes;
